export default {
  AUTO_SUGGEST: 'auto-suggest',
  TEXT_FIELD: 'text-field',
  TEXT_AREA: 'text-area',
  ADDRESS: 'address',
  ADDRESS_INTERNATIONAL: 'address-(international)',
  POSTCODE: 'postcode',
  DATE_OF_BIRTH: 'date-of-birth',
  CHECKBOXES: 'checkboxes',
  RADIO_BUTTONS: 'radio-buttons',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone-number',
  PHONE_NUMBER_INTERNATIONAL: 'phone-number-(international)',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  FILE_UPLOAD: 'file-upload',
  SECTION_BREAK: 'section-break',
};
